// extracted by mini-css-extract-plugin
module.exports = {"search-wrapper":"Home_search-wrapper__1jVuB","search-wrapper-results":"Home_search-wrapper-results__1yfm4","pagination-container":"Home_pagination-container__2Gsxu"};